<template>
  <page>
    <div slot="pageAction">
      <div class="actionBlock">
        <v-menu offset-y :min-width="250">
          <template v-slot:activator="{ on }">
            <v-btn text color="secondary" v-on="on">
              Related Tasks
              <v-icon right>mdi-link</v-icon>
            </v-btn>
          </template>
          <side-function-menu :items="sideFunction" @doClick="$router.push($event)"></side-function-menu>
        </v-menu>
      </div>
    </div>
    <div>
      <v-flex xs12>
        <form>
          <v-expansion-panels>
          <v-expansion-panel>
              <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Filters
              </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xl3 lg6 xs6>
                        <v-text-field v-model="filters.scheme" :label="labels.scheme" :error-messages="errors.collect('scheme')" data-vv-name="scheme" :data-vv-as="labels.scheme" v-validate="'name|max:4'"></v-text-field>
                      </v-flex>
                      <v-flex xl3 lg6 xs6>
                        <v-text-field v-model="filters.schemeDesc" :label="labels.schemeDesc" :error-messages="errors.collect('schemeDesc')" data-vv-name="schemeDesc" :data-vv-as="labels.schemeDesc" v-validate="'max:40'"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </form>
      </v-flex>
      <v-spacer class="mt-2"></v-spacer>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.native="doNew">
            New Scheme<v-icon right>mdi-plus</v-icon>
          </v-btn>
        </v-card-title>
        <v-flex>
          <v-card>
            <v-data-table :headers="headers" :items="items" v-bind:options.sync="pagination" :server-items-length="totalItems" :loading="loading" :footer-props="{'items-per-page-options': itemsPerPage }" :no-data-text="noDataText">
              <template v-slot:item="row"><tr>
                <td>{{ row.item.scheme }}</td>
                <td class="text-xs-left">{{ row.item.schemeDesc }}</td>
                <td class="text-xs-left">{{ formatDate(row.item.effDate) }}</td>
                <td class="text-xs-left">{{ formatDate(row.item.expDate) }}</td>
                <td class="table-action-header">
                  <table-action :rowData="row" review @review="doReview" remove @remove="doPromptRemove"></table-action>
                </td>
              </tr></template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card>
      <confirm v-model="promptRemove" @ok="doRemove">
        Please confirm deletion of this records. ( {{ selectedScheme.scheme }} )
      </confirm>
    </div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'

export default {
  data() {
    return {
      sideFunction: [
        // {
        //   text: 'Campaign',
        //   icon: 'mdi-launch',
        //   iconColor: 'primary',
        //   params: { name: '' }
        // },
        {
          text: 'Default Clause',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'schemeClause' }
        },
        {
          text: 'Duration',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'duration' }
        },
        {
          text: 'No Claim Bonus',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'dmncbParam' }
        },
        {
          text: 'Package Plan',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'pkgPlan' }
        },
        {
          text: 'Package Tariff Benefit',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'pckgTariffBen' }
        },
        {
          text: 'Package Tariff Factor',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'pckgTariffFact' }
        },
        // {
        //   text: 'Package Tariff Rate',
        //   icon: 'mdi-launch',
        //   iconColor: 'primary',
        //   params: { name: '' }
        // },
        // {
        //   text: 'Scheme',
        //   icon: 'mdi-tune',
        //   iconColor: 'primary',
        //   params: { name: 'scheme' }
        // },
        {
          text: 'Permit Policy Type',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'polTypeScheme' }
        },
        {
          text: 'Package Standard Risk Text',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'pkgStdRiskTxt' }
        },
        {
          text: 'Scheme Duration',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'schemeDuration' }
        }
      ],
      toogleArray: [false],
      headers: [
        { text: 'Scheme', align: 'left', value: 'scheme' },
        { text: 'Description', value: 'schemeDesc' },
        { text: 'Effective Date', value: 'effDate' },
        { text: 'Expiry Date', value: 'expDate' },
        TableConst.tableActionHeader
      ],
      labels: {
        scheme: 'Scheme',
        schemeDesc: 'Description'
      },
      filters: {
        scheme: null,
        schemeDesc: null
      },
      loading: false,
      promptRemove: false,
      selectedScheme: {},
      totalItems: 0,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  async mounted() {
    if (this.$store.state.pkgParam.scheme.init !== 1) {
      await this.$store.dispatch('schemeInit')
    }
    this.doInit(true)
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination': function (value) {
      this.doInit(false)
    }
  },
  computed: {
    schMenu() {
      return this.$store.state.pkgParam.scheme.menu
    }
  },
  methods: {
    async doInit(options) {
      this.resetMessages()
      const apiURI = this.schMenu.getSchemeList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((scheme) => {
                const convertList = {
                  scheme: scheme.scheme,
                  schemeDesc: scheme.schemeDesc,
                  schemeType: scheme.schemeType,
                  effDate: scheme.effDate,
                  expDate: scheme.expDate
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filters.scheme = null
      this.filters.schemeDesc = null
      this.pagination.page = 1
      this.doInit(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.pagination.page = 1
          this.doInit(false)
        }
      })
    },
    doNew() {
      this.$router.push({ name: 'schemeReview', params: { scheme: 'new' } })
    },
    doReview(data) {
      this.$router.push({ name: 'schemeReview', params: { scheme: data.item.scheme } })
    },
    doPromptRemove(data) {
      this.resetMessages()
      this.selectedScheme = data.item
      this.promptRemove = true
    },
    async doRemove(data) {
      const apiURI = this.schMenu.deleteScheme
      if (apiURI) {
        const expand = this.selectedScheme
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.doInit(false)
          })
          .catch((err) => {
            const { data } = err.response
            this.message(data)
          })
      }
    }
  },
  mixins: [TableConst.default, MessageMixin],
  components: {
    SideFunctionMenu
  }
}
</script>
